import React from "react";

export default () => (
    <svg width="8" height="13" viewBox="0 0 8 13" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0.589966 11.34L5.16997 6.75L0.589966 2.16L1.99997 0.75L7.99997 6.75L1.99997 12.75L0.589966 11.34Z" fill="black" />
    </svg>

);



// WEBPACK FOOTER //
// ./src/icons/arrow.js